import { collection, getDocs, deleteDoc, setDoc, doc, updateDoc, query, where, onSnapshot, or, and } from "firebase/firestore";
import { db } from '../firebase-config';
import React, {useState, createContext, useEffect, useCallback} from 'react';
import axios from 'axios';
import { getUserInfo } from "../components/Login";
import { defaultProspectModel, defaultTeamModel} from "./Models";
import dayjs from 'dayjs';
import { fetchPropertyByAddress } from '../services/corelogic';
// trigger deployment

export const AppCTX = createContext();

export default function AppContext({children}) {
  const [user, setUser] = useState({
    uid: null,
    data: null,
  });
  const [prospects, setProspects] = useState([])
  const [openAddProspect, setOpenAddProspect] = React.useState(false);
  const [getPropertyDetails, setGetPropertyDetails] = useState(false)
  const [appointments, setAppointments] = useState([])
  const [leadType, setLeadType] = useState(0)
  const [status, setStatus] = useState('neutral')
  const [map, setMap] = useState(null);
  const [newProspect, setNewProspect] = useState(defaultProspectModel)
  const [teamData, setTeamData] = useState(defaultTeamModel)
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [propertyInsights, setPropertyInsights] = useState(null);
  const [propertyInsightsLoading, setPropertyInsightsLoading] = useState(false);
  const [propertyInsightsError, setPropertyInsightsError] = useState(null);
  useEffect(()=>{
    console.log('map loaded',isMapLoaded )
  },[isMapLoaded])

  //  When user joins this app for the first time
  // Define functions first to avoid circular dependency
  const getProspects = useCallback(async () => {
    try {
      // Get all prospects
      const q = query(collection(db, "prospects"), where("setter", "==", user.data.name));
      onSnapshot(q, (snapshot) => {
        console.log('Pulling prospects from db :', snapshot)
        let update = [...prospects];
        snapshot.forEach((doc) => {
          update.push(doc.data())
        })

        // seperate prospects to a new array
        const appointments = [];
        for (let i = update.length - 1; i >= 0; i--) {
          if (update[i].appointmentStart !== null) {
            appointments.push(update[i]);
            update.splice(i, 1); // Remove the object from the original array
          }
        }

        console.log('appointments found:', appointments)
        setAppointments(appointments)

        console.log('Prospects pulled in from firebase', update)
        setProspects(update)

      });
    } catch (error) {
      console.log(error)
      setStatus({notificationType:'error', message: 'error loading'});
      return [];
    }
  }, [user.data?.name, prospects, setAppointments, setProspects, setStatus])

  const getAppointments = useCallback(async () => {
    try {
      let q = query(collection(db, "prospects"),and( or(where("closer", "==", user.data.name), where("setter", "==", user.data.name)), where("appointmentSet", "==", true)));
      onSnapshot(q, (snapshot) => {
        console.log('Pulling appointments from db :', snapshot)
        let update = [];
        snapshot.forEach((doc) => {
          update.push(doc.data())
        })

        console.log('appointments found:', update)
        setAppointments(update)
      });
    } catch (error) {
      console.log(error)
      setStatus({notificationType:'error', message: 'error loading'});
      return [];
    }
  }, [user.data?.name, setAppointments, setStatus])

  useEffect(()=>{
    // below logic is to handle auto login via extracting the uid from local storage
    if (typeof localStorage !== 'undefined' && user.uid==null) {
      const uid = localStorage.getItem('firebase-uid');
      if(uid !== null){
        getUserInfo({uid:uid}).then((info)=>{
          setUser(info)
        })
      }
    } else {
      console.log('Local storage is not supported or UID does not exist in local storage');
    }
    // if user is authenticated
    if(user.uid!==null && user.data!=null){
      console.log('USER FOUND', user)
      getProspects()
      getTeamData()
      getAppointments()
    }
  },[user])

  useEffect(() =>{
    if(leadType > 0){
      setNewProspect(defaultProspectModel)
    }
  },[leadType])

  // Removed unused getPreciselyToken function


  const addProspect = async (newProspect) => {
    try{
        console.log('creating payload', newProspect);
        await setDoc(doc(db, "prospects", newProspect.address), newProspect)
        setStatus({notificationType:'success', message: 'prospect added successfully'})
        
        // Clear the coordinates after successful addition to remove pin and buttons
        setNewProspect(prev => ({
          ...prev,
          coords: null
        }))

      }catch(err){
        console.error(err)
        setStatus({notificationType:'error', message: 'something went wrong'})
      }
  }

  const updateProspect = async (updateProspect) => {
    try{
        console.log('creating payload', updateProspect);
        await setDoc(doc(db, "prospects", updateProspect.address), updateProspect)
        setStatus({notificationType:'success', message: 'client updated successfully'})
      }catch(err){
        console.error(err)
        setStatus({notificationType:'error', message: 'something went wrong'})
      }
  }

  const scheduleAppointment = async (prospect, day, time, selectedCloser, setNewAppointment ) =>{
    let dateTime = dayjs(day).format('YYYY-MM-DD')+"T"+dayjs(time).format('HH:mm')
    const prospectRef = doc(db, 'prospects', prospect.address);
    try {
      // Update the prospect document
      await updateDoc(prospectRef, {
        appointmentStart: dateTime,
        closer: selectedCloser,
        appointmentSet: true,
      });

      setStatus({notificationType:'success', message: 'appointment added'})
    } catch (error) {
      console.error('Error updating prospect:', error);
    }
  }

  const deleteProspect = async (address) => {
    try{
      const prospectRef = collection(db, "prospects");
      // Create a query against the collection.
      const q = query(prospectRef, where("address", "==", address));
      const querySnapshot = await getDocs(q);
      let docId = null;
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        docId = doc.id
      });

      await deleteDoc(doc(db, "prospects", docId));

    }catch(err){
      console.error(err)
      setStatus({notificationType:'error', message: 'something went wrong'})
    }
  }

  const sendSmsReminders = async (hopBackTime) => {
    const url = `http://localhost:5001/door-hopper/us-central1/helloWorld`;
    console.log('sending message')
    try{
      await axios.post(url, {address: newProspect.address, time: hopBackTime});
      setStatus({notificationType:'success', message: 'SMS notifcations setup successfully'})
    }catch(err){
      setStatus({notificationType:'error', message: 'Something went wrong'})
    }
  }

  const getTeamData = async () => {
    // Always use the env variable for team name
    const teamName = process.env.REACT_APP_TEAMNAME || 'DeltaPower';
    const docRef = doc(db, "teams", teamName);
    try{
        onSnapshot(docRef, (snapshot) => {
        const team = snapshot.data()
        console.log('retrieved team data',team)
        setTeamData(team)
      })
    }catch(err){
      console.log(err)
    }
  }

  const updateTeamData = async (dataToSave) => {
    const data = dataToSave || teamData;
    console.log('saving team data', data)
    try{
        await setDoc(doc(db, "teams", user.data.teamName), data)
        setStatus({notificationType:'success', message: 'new area assigned successfully'})
    }catch(err){
        console.log(err)
    }
  }

  const addAddress = useCallback(async () => {
    try {
      if (!newProspect?.coords?.lat || ! process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
        setStatus({ notificationType: 'error', message: 'Missing coordinates or API key' });
        return;
      }
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${newProspect.coords.lat},${newProspect.coords.lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      const { data } = await axios.get(url);
      console.log('response data ;',data)
      if (!data?.results?.[0]?.formatted_address) {
        setStatus({ notificationType: 'error', message: 'API ERROR' });
        return;
      }else{
        const temp = {...newProspect, address:data?.results?.[0]?.formatted_address}
        console.log('address added', temp)
        setNewProspect(temp)
      }
    } catch (error) {
      console.error('Address error:', error);
      setStatus({ 
        notificationType: 'error', 
        message: error.response?.data?.error_message || 'API ERROR'
      });
    }
  }, [newProspect, setStatus, setNewProspect]);

  // Fetch CoreLogic property insights by address and enrich newProspect
  const fetchPropertyInsights = async (addressObj) => {
    setPropertyInsightsLoading(true);
    setPropertyInsightsError(null);
    setPropertyInsights(null);
    try {
      // Parse zip code from address if not provided
      let zipCode = addressObj.zipCode;
      console.log('[CoreLogic] Initial zip code from addressObj:', zipCode);
      
      if (!zipCode && addressObj.streetAddress) {
        // Extract zip code from the end of the address (e.g., "123 Main St, City, TX 75009")
        const zipMatch = addressObj.streetAddress.match(/\b\d{5}\b/);
        if (zipMatch) {
          zipCode = zipMatch[0];
          console.log('[CoreLogic] Extracted zip code from addressObj.streetAddress:', zipCode);
        }
      }

      // If we still don't have a zip code, try to extract from newProspect.address
      if (!zipCode && newProspect?.address) {
        const zipMatch = newProspect.address.match(/\b\d{5}\b/);
        if (zipMatch) {
          zipCode = zipMatch[0];
          console.log('[CoreLogic] Extracted zip code from newProspect.address:', zipCode);
        }
      }

      if (!zipCode) {
        console.error('[CoreLogic] No zip code found in:', {
          addressObj,
          newProspectAddress: newProspect?.address
        });
        throw new Error('Zip code is required for property search. Please ensure the address includes a zip code.');
      }

      // Prepare address object with zip code
      const addressWithZip = {
        streetAddress: addressObj.streetAddress,
        city: addressObj.city || '',
        state: addressObj.state || '',
        zipCode: zipCode
      };

      console.log('[CoreLogic] Fetching property insights with:', addressWithZip);
      
      // addressObj: { streetAddress, city, state, zipCode }
      const data = await fetchPropertyByAddress(addressWithZip);
      setPropertyInsights(data);
      console.log('[CoreLogic] Property Insights:', data);
      
      // Enrich newProspect with CoreLogic data
      if (data) {
        const enrichedProspect = { ...newProspect };
        
        // Extract homeowner information
        const ownership = data.ownership;
        if (ownership?.currentOwners) {
          const owners = ownership.currentOwners.ownerNames || [];
          
          // Filter out null/empty owners and only include valid ones
          const validOwners = owners.filter(owner => 
            owner && 
            owner.fullName && // Must have a fullName
            owner.fullName.trim() !== '' // Must not be empty string
          );
          
          console.log('[CoreLogic] Owner analysis:', {
            total: owners.length,
            valid: validOwners.length,
            nullCount: owners.length - validOwners.length,
            validOwners: validOwners.map(o => o.fullName)
          });
          
          // Convert to prospect owner format (for AddProspect form)
          enrichedProspect.owners = validOwners.map(owner => ({
            name: owner.fullName.trim(),
            number: '', // Phone numbers not available from CoreLogic
            isCorporate: owner.isCorporate || false
          }));
          
          // Determine initial marker status based on mailing address comparison
          const mailingInfo = ownership.currentOwnerMailingInfo;
          
          // If mailing address is different from property address, it's likely a renter
          if (mailingInfo?.mailingAddress?.streetAddress && 
              mailingInfo.mailingAddress.streetAddress !== data.propertyAddress?.streetAddress) {
            enrichedProspect.markerStatus = 'renter';
          } else {
            enrichedProspect.markerStatus = 'default';
          }
          
          // Add property details
          enrichedProspect.propertyDetails = {
            clipId: data.clip,
            propertyAddress: data.propertyAddress,
            ownership: ownership
          };
          
          console.log('[CoreLogic] Enriched prospect with:', {
            owners: enrichedProspect.owners,
            markerStatus: enrichedProspect.markerStatus,
            propertyDetails: enrichedProspect.propertyDetails
          });
          
          setNewProspect(enrichedProspect);
        }
      }
    } catch (err) {
      setPropertyInsightsError(err.message || 'Failed to fetch property insights');
      setPropertyInsights(null);
      console.error('[CoreLogic] Error:', err);
    } finally {
      setPropertyInsightsLoading(false);
    }
  };

  // Auto-fetch address whenever newProspect has coords but no address
  useEffect(() => {
    if (newProspect?.coords && !newProspect?.address) {
      console.log('[Address] Auto-fetching address for new coordinates:', newProspect.coords);
      addAddress();
    }
  }, [newProspect?.coords?.lat, newProspect?.coords?.lng, newProspect?.address, addAddress]);

  // Clear property insights and address when coordinates change (new location selected)
  useEffect(() => {
    if (newProspect?.coords) {
      console.log('[CoreLogic] Coordinates changed, clearing previous property insights and address');
      setPropertyInsights(null);
      setPropertyInsightsError(null);
      setPropertyInsightsLoading(false);
      
      // Clear the old address to prevent using stale data
      setNewProspect(prev => ({
        ...prev,
        address: '', // Clear old address when coordinates change
        owners: [], // Clear old owner data
        markerStatus: 'default', // Reset marker status
        propertyDetails: null // Clear property details
      }));
    }
  }, [newProspect?.coords?.lat, newProspect?.coords?.lng, newProspect?.coords]);

  // Function to manually clear property insights
  const clearPropertyInsights = () => {
    setPropertyInsights(null);
    setPropertyInsightsError(null);
    setPropertyInsightsLoading(false);
  };

  return (
    <AppCTX.Provider value={{
        isMapLoaded,
        setIsMapLoaded,
        setMap,
        map,
        status,
        setStatus,
        sendSmsReminders,

        prospects,
        setProspects,
        getProspects,
        newProspect,
        setNewProspect,
        addProspect,
        updateProspect,
        deleteProspect,

        leadType,
        setLeadType,

        appointments,
        setAppointments,
        scheduleAppointment,

        user,
        setUser,

        teamData,
        setTeamData,
        updateTeamData,

        openAddProspect,
        setOpenAddProspect,
        addAddress,

        getPropertyDetails,
        setGetPropertyDetails,
        propertyInsights,
        setPropertyInsights,
        propertyInsightsLoading,
        propertyInsightsError,
        fetchPropertyInsights,
        clearPropertyInsights,
      }}>
      {children}
    </AppCTX.Provider>
  )
}
